export default "__VITE_ASSET__5_4yMLyn__"